import { ErrorBanner } from '../ui/index.jsx'

/**
 * PEMV P6 — onboarding step for creating the tenant's first venue (a `locations`
 * row of type 'site'). Mirrors DepartmentStep. The wizard owns the state +
 * saveVenue (which POSTs /locations) and renders this presentational component.
 */
interface VenueStepProps {
  venueName: string
  setVenueName: (name: string) => void
  saveVenue: () => void
  error: string
  setError: (error: string) => void
  loading: boolean
  goNext: () => void
  t: (key: string) => string
}

export default function VenueStep({
  venueName, setVenueName, saveVenue, error, setError, loading, goNext, t,
}: VenueStepProps) {
  return (
    <div>
      <h2 style={{ fontSize: 'var(--text-2xl)', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8 }}>
        {t('onboardingVenueTitle')}
      </h2>
      <p style={{ fontSize: 'var(--text-base)', color: 'var(--text-muted)', marginBottom: 32 }}>
        {t('onboardingVenueDesc')}
      </p>

      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: 'var(--text-caption)', fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: 8 }}>
          {t('venueNameLabel')} *
        </label>
        <input
          type="text"
          value={venueName}
          onChange={e => setVenueName(e.target.value)}
          autoFocus
          onKeyDown={e => e.key === 'Enter' && saveVenue()}
          style={{
            width: '100%', padding: '11px 14px', fontSize: 'var(--text-md)', boxSizing: 'border-box',
            background: 'var(--bg-elevated)', border: '1px solid var(--border-default)',
            borderRadius: 8, color: 'var(--text-primary)', outline: 'none',
          }}
          onFocus={e => e.target.style.borderColor = 'var(--accent)'}
          onBlur={e => e.target.style.borderColor = 'var(--border-default)'}
        />
      </div>

      <div style={{
        display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28,
        background: 'var(--bg-elevated)', borderRadius: 8, padding: '10px 14px',
      }}>
        <span style={{ fontSize: 'var(--text-base)', fontWeight: 500, color: 'var(--text-primary)' }}>
          {venueName || t('yourVenue')}
        </span>
      </div>

      <ErrorBanner style={{ fontSize: 'var(--text-caption)', marginBottom: 12 }}>{error}</ErrorBanner>

      <div style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={() => { setError(''); goNext() }}
          style={{
            flex: 1, padding: '13px', borderRadius: 10,
            background: 'var(--bg-elevated)', color: 'var(--text-secondary)',
            border: '1px solid var(--border-default)', fontSize: 'var(--text-base)', cursor: 'pointer',
          }}
        >
          {t('skipForNow')}
        </button>
        <button
          onClick={saveVenue}
          disabled={loading}
          style={{
            flex: 2, padding: '13px', borderRadius: 10,
            background: loading ? 'var(--bg-elevated)' : 'var(--accent)',
            color: loading ? 'var(--text-muted)' : 'var(--text-inverse)',
            border: 'none', fontSize: 'var(--text-md)', fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? t('creatingVenue') : t('createVenue')}
        </button>
      </div>
    </div>
  )
}
